export enum HttpResponseErrorType {
  TERMS_AND_CONDITIONS_NOT_ACCEPTED_EXCEPTION = 'TermsAndConditionsNotAcceptedException',
  WRONG_CMS_SITE = 'WRONG_CMS_SITE',
  RESET_PASSWORD_NOT_ALLOWED_ERROR = 'ResetPasswordNotAllowedError',
  UNKNOWN_IDENTIFIER_ERROR = 'UnknownIdentifierError',
  ILLEGAL_ARGUMENT_ERROR = 'IllegalArgumentError',
  JCO_ERROR_COMMUNICATION = 'JCoRuntimeException',
  BACKEND_COMMUNICATION_EXCEPTION = 'BackendCommunicationException',
  BACKEND_OFFLINE_EXCEPTION = 'BackendOfflineException',
  PASSWORD_POLICY_VIOLATION_EXCEPTION = 'PasswordPolicyViolationError'
}
